import { createContext, useContext } from "react";

type ToastOptions = {
  description?: string;
};

export type ToastContextValue = {
  showInfo: (title: string, options?: ToastOptions) => void;
  showError: (title: string, options?: ToastOptions) => void;
  /**
   * The error toast for a failed request. `title` says what failed; the description is the
   * server's message only when `describeSafeErrorMessage` allows it, and absent otherwise. Use it
   * instead of passing `error.message` to `showError`: for an unhandled server error that is
   * database or stack text.
   */
  showMutationError: (title: string, error: unknown) => void;
  showSuccess: (title: string, options?: ToastOptions) => void;
};

const noop = () => {
  // intentionally empty
};

const toastContextDefaultValue: ToastContextValue = {
  showInfo: noop,
  showError: noop,
  showMutationError: noop,
  showSuccess: noop,
};

export const ToastContext = createContext<ToastContextValue>(toastContextDefaultValue);

export const useToast = () => useContext(ToastContext);
